export class ProductLocationsStock extends HTMLElement {
  constructor() {
    super();

    // We use a setTimeout so the vueJS doesn't rewrite the component
    setTimeout(() => {
      this.sidebarOverlay = document.querySelector('.product-locations-drawer__overlay');

      this.attachEventListeners();

      this.getJSONData();
    }, 100);
  }

  attachEventListeners() {
    // Handle Drawer
    this.openDrawerButton.addEventListener('click', this.openDrawer.bind(this));
    this.closeDrawerButton.addEventListener('click', this.closeDrawer.bind(this));
    this.sidebarOverlay.addEventListener('click', this.closeDrawer.bind(this));

    // Handle Select
    this.querySelector('.product-locations-variants__selected')?.addEventListener('click', this.stateSelectVariant.bind(this));
    document.addEventListener('click', this.handleClickOutside.bind(this));

    // Handle select variant change
    this.querySelectorAll('.product-locations-variants__item').forEach((item) => {
      item.addEventListener('click', this.selectVariant.bind(this));
    });

    // Handle FP variant Change
    document.addEventListener('variant:change', this.handleVariantChange.bind(this));
  }

  // Handle Drawer
  get openDrawerButton() {
    return document.querySelector('[aria-controls="product-locations-list"]');
  }

  get closeDrawerButton() {
    return this.querySelector('[aria-controls="product-locations-list"]');
  }

  openDrawer() {
    this.setAttribute('aria-expanded', 'true');
    this.sidebarOverlay.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
  }

  closeDrawer() {
    this.setAttribute('aria-expanded', 'false');
    this.sidebarOverlay.classList.remove('active');
    document.documentElement.style.overflow = '';
  }

  // Handle Variant
  getJSONData() {
    let data = this.querySelector('#product-locations-variants-stock');
    this.dataJSON = JSON.parse(data.innerHTML);
  }

  handleVariantChange(event) {
    this.updateSelectedVariantInSidebar(event?.detail?.variantId);
  }

  updateSelectedVariantInSidebar(variantId) {
    const variantElement = this.querySelector(`.product-locations-variants__item[variant-id="${variantId}"]`);
    if (variantElement) {
      this.selectVariant({ currentTarget: variantElement });
    }
  }

  selectVariant(event) {
    const itemElement = event?.currentTarget;

    if (!itemElement) return;

    const targetVariantId = itemElement.getAttribute('variant-id');
    const targetImg = itemElement.getAttribute('data-image-url');
    const targetTitle = itemElement.getAttribute('variant-title');
    const targetPrice = itemElement.getAttribute('variant-price');
    const targetCompareAtPrice = itemElement.getAttribute('variant-compare-at-price');

    this.querySelectorAll('.product-locations-variants__item').forEach((item) => {
      item.setAttribute('aria-selected', 'false');
    });

    itemElement.setAttribute('aria-selected', 'true');

    // Title product management
    this.querySelector('.product-locations__title').textContent = targetTitle;

    // Title variant management
    this.querySelector('.product-locations__selected-variant').innerText = itemElement.querySelector('span')?.innerHTML;

    // Img management
    this.querySelector('.product-locations-sidebar__product-wrapper img').srcset = targetImg;

    // Price management
    this.querySelector('.product-locations__price').textContent = targetPrice;
    if (targetCompareAtPrice) {
      this.querySelector('.product-locations__info-price').classList.add('variant-compare')
      this.querySelector('.product-locations__compare-at-price').textContent = targetCompareAtPrice;
    } else {
      this.querySelector('.product-locations__info-price').classList.remove('variant-compare')
    }

    // Color management
    this.querySelector('.product-locations-item__selected-variant-color')?.style.setProperty('--selected-variant-color-background', itemElement.getAttribute('variant-color'));

    this.updateStock(targetVariantId);
    this.closeSelectVariant();
  }

  updateStock(targetVariantId) {
    let targetStock = this.dataJSON[targetVariantId];
    let displayedBoutiques = this.querySelectorAll('.location-list__item');
    // Addition of a safety mechanism when the location is not present on all variants
    displayedBoutiques.forEach((displayedBoutique) => {
      let stockMessages = displayedBoutique.querySelectorAll('.location-list__item-stock-message');
      let outOfStockMessage = displayedBoutique.querySelector('.location__out-of-stock');
      stockMessages.forEach((stockMessage) => {
        stockMessage.classList.add('hidden');
        outOfStockMessage.classList.remove('hidden');
      });
    });
    // Object entries splits the JSON into two arrays, [0] for the key (which is the boutique name) and [1] for the values.
    Object.entries(targetStock).forEach((stockBoutique) => {
      if (!stockBoutique) return;

      let boutiqueName = stockBoutique[0];
      let boutiqueStock = stockBoutique[1]?.stock;

      let displayedBoutiques = this.querySelectorAll('.location-list__item');
      displayedBoutiques.forEach((displayedBoutique) => {
        let boutiqueNameDisplayed = displayedBoutique.querySelector('.location-list__item-name').textContent;

        if (boutiqueName === boutiqueNameDisplayed) {
          let stockMessages = displayedBoutique.querySelectorAll('.location-list__item-stock-message');
          let outOfStockMessage = displayedBoutique.querySelector('.location__out-of-stock');
          let almostEmptyMessage = displayedBoutique.querySelector('.location__almost-empty');
          let inStockMessage = displayedBoutique.querySelector('.location__in-stock');
          let almostEmptyNumber = this.getAttribute('stock-almost-empty')

          stockMessages.forEach((stockMessage) => {
            stockMessage.classList.add('hidden');

            if (boutiqueStock <= 0) {
              outOfStockMessage.classList.remove('hidden');
            } else if (boutiqueStock <= almostEmptyNumber) {
              almostEmptyMessage.classList.remove('hidden');
            } else {
              inStockMessage.classList.remove('hidden');
            }
          });
        }
      });
    });
  }

  // Handle Select

  stateSelectVariant() {
    if (this.querySelector('.product-locations-variants__wrapper')?.getAttribute('aria-expanded') === 'true') {
      this.closeSelectVariant();
    } else {
      this.openSelectVariant();
    }
  }

  openSelectVariant() {
    this.querySelector('.product-locations-variants__wrapper')?.setAttribute('aria-expanded', 'true');
    if (this.querySelector('#icon-dropdown-arrow-thick')) {
      this.querySelector('#icon-dropdown-arrow-thick').style.transform = 'rotate(180deg)';
    }
  }

  closeSelectVariant() {
    this.querySelector('.product-locations-variants__wrapper')?.setAttribute('aria-expanded', 'false');
    if (this.querySelector('#icon-dropdown-arrow-thick')) {
      this.querySelector('#icon-dropdown-arrow-thick').style.transform = 'rotate(0deg)';
    }
  }

  handleClickOutside(event) {
    if (!this.querySelector('.product-locations-variants__wrapper')?.contains(event.target) && !this.querySelector('.product-locations-variants__selected')?.contains(event.target)) {
      this.closeSelectVariant();
    }
  }
}

try {
  window.customElements.define('product-locations-stock', ProductLocationsStock);
} catch (e) { }
